const xxssList = {
    instagram: {
        urlPath: 'urlInstagram',
        icon: 'instagram',
        alt: 'Instagram'
    },
    whatsapp: {
        urlPath: 'urlWhatsapp',
        icon: 'whatsapp',
        alt: 'Whatsapp'
    },
    youtube: {
        urlPath: 'urlYoutube',
        icon: 'youtube',
        alt: 'Youtube'
    },
    tiktok: {
        urlPath: 'urlTiktok',
        icon: 'tiktok',
        alt: 'Tiktok'
    },
    telegram: {
        urlPath: 'urlTelegram',
        icon: 'telegram',
        alt: 'Telegram'
    },
    facebook: {
        urlPath: 'urlFacebook',
        icon: 'facebook',
        alt: 'Facebook'
    },
    x: {
        urlPath: 'urlTwitter',
        icon: 'x',
        alt: 'X'
    },
    podcastSpotify: {
        urlPath: 'podcastSpotify',
        icon: 'spotify',
        alt: 'Spotify Podcast',
        isPodcast: true
    },
    podcastApple: {
        urlPath: 'podcastApple',
        icon: 'applepodcast',
        alt: 'Apple Podcast',
        isPodcast: true
    },
    podcastAmazon: {
        urlPath: 'podcastAmazon',
        icon: 'amazonmusic',
        alt: 'Amazon Music',
        isPodcast: true
    },
    iVoox: {
        urlPath: 'urlIVoox',
        icon: 'ivoox',
        alt: 'iVoox',
        isPodcast: true
    },
    spotify: {
        urlPath: 'urlSpotify',
        icon: 'spotify',
        alt: 'Spotify'
    },
    rss: {
        urlPath: 'urlRSS',
        icon: 'rss',
        alt: 'rss'
    }
};

export { xxssList };
